export const EXCLUDED_FUEL_TYPES = ['FUELTYPE_ETHANOL', 'FUELTYPE_HYDROGEN', 'FUELTYPE_OTHER'];
